import Helpers from './libs/helper-utils';
// REQUIRES
require('./bootstrap');

var northAmericanStates = {
  "AL": "Alabama",
  "AK": "Alaska",
  "AS": "American Samoa",
  "AZ": "Arizona",
  "AR": "Arkansas",
  "CA": "California",
  "CO": "Colorado",
  "CT": "Connecticut",
  "DE": "Delaware",
  "DC": "District Of Columbia",
  "FM": "Federated States Of Micronesia",
  "FL": "Florida",
  "GA": "Georgia",
  "GU": "Guam",
  "HI": "Hawaii",
  "ID": "Idaho",
  "IL": "Illinois",
  "IN": "Indiana",
  "IA": "Iowa",
  "KS": "Kansas",
  "KY": "Kentucky",
  "LA": "Louisiana",
  "ME": "Maine",
  "MH": "Marshall Islands",
  "MD": "Maryland",
  "MA": "Massachusetts",
  "MI": "Michigan",
  "MN": "Minnesota",
  "MS": "Mississippi",
  "MO": "Missouri",
  "MT": "Montana",
  "NE": "Nebraska",
  "NV": "Nevada",
  "NH": "New Hampshire",
  "NJ": "New Jersey",
  "NM": "New Mexico",
  "NY": "New York",
  "NC": "North Carolina",
  "ND": "North Dakota",
  "MP": "Northern Mariana Islands",
  "OH": "Ohio",
  "OK": "Oklahoma",
  "OR": "Oregon",
  "PW": "Palau",
  "PA": "Pennsylvania",
  "PR": "Puerto Rico",
  "RI": "Rhode Island",
  "SC": "South Carolina",
  "SD": "South Dakota",
  "TN": "Tennessee",
  "TX": "Texas",
  "UT": "Utah",
  "VT": "Vermont",
  "VI": "Virgin Islands",
  "VA": "Virginia",
  "WA": "Washington",
  "WV": "West Virginia",
  "WI": "Wisconsin",
  "WY": "Wyoming",
  "BC": "British Columbia",
  "ON": "Ontario",
  "NL": "Newfoundland and Labrador",
  "NS": "Nova Scotia",
  "PE": "Prince Edward Island",
  "NB": "New Brunswick",
  "QC": "Quebec",
  "MB": "Manitoba",
  "SK": "Saskatchewan",
  "AB": "Alberta",
  "NT": "Northwest Territories",
  "NU": "Nunavut",
  "YT": "Yukon Territory",
  "DIF": "Distrito Federal",
  "AGU": "Aguascalientes",
  "BCN": "Baja California",
  "BCS": "Baja California Sur",
  "CAM": "Campeche",
  "COA": "Coahuila",
  "COL": "Colima",
  "CHP": "Chiapas",
  "CHH": "Chihuahua",
  "DUR": "Durango",
  "GUA": "Guanajuato",
  "GRO": "Guerrero",
  "HID": "Hidalgo",
  "JAL": "Jalisco",
  "MEX": "México",
  "MIC": "Michoacán",
  "MOR": "Morelos",
  "NAY": "Nayarit",
  "NLE": "Nuevo León",
  "OAX": "Oaxaca",
  "PUE": "Puebla",
  "QUE": "Querétaro",
  "ROO": "Quintana Roo",
  "SLP": "San Luis Potosí",
  "SIN": "Sinaloa",
  "SON": "Sonora",
  "TAB": "Tabasco",
  "TAM": "Tamaulipas",
  "TLA": "Tlaxcala",
  "VER": "Veracruz",
  "YUC": "Yucatán",
  "ZAC": "Zacatecas"
};

(function () {
  var method;
  var noop = function () { };
  var methods = [
    'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
    'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
    'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
    'timeStamp', 'trace', 'warn'
  ];
  var length = methods.length;
  var console = (window.console = window.console || {});

  while (length--) {
    method = methods[length];

    // Only stub undefined methods.
    if (!console[method]) {
      console[method] = noop;
    }
  }
}());

Masonry.prototype._getMeasurement = function (measurement, size) {
  var option = this.options[measurement];
  var elem;
  if (!option) {
    // default to 0
    this[measurement] = 0;
  } else if (typeof option === 'function') {
    this[measurement] = option.call(this);
  } else {
    // use option as an element
    if (typeof option === 'string') {
      elem = this.element.querySelector(option);
    } else if (isElement(option)) {
      elem = option;
    }
    // use size of element, if element
    this[measurement] = elem ? getSize(elem)[size] : option;
  }
};

function parseURL(url) {

  var parser = document.createElement('a'),
    searchObject = {},
    queries, split, i;
  // Let the browser do the work
  parser.href = url;
  // Convert query string to object
  queries = parser.search.replace(/^\?/, '').split('&');
  for (i = 0; i < queries.length; i++) {
    split = queries[i].split('=');
    searchObject[split[0]] = split[1];
  }
  return {
    protocol: parser.protocol,
    host: parser.host,
    hostname: parser.hostname,
    port: parser.port,
    pathname: parser.pathname,
    search: parser.search,
    searchObject: searchObject,
    hash: parser.hash
  };

}

function updateQueryStringParameter(uri, key, value) {
  var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
  var separator = uri.indexOf('?') !== -1 ? "&" : "?";
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + "=" + value + '$2');
  }
  else {
    return uri + separator + key + "=" + value;
  }
}

jQuery(document).ready(function ($) {

  $.fn.exists = function () { return this.length > 0; }

  $.fn.serializeObject = function () {
    var o = {};
    var a = this.serializeArray();
    $.each(a, function () {
      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(this.value || '');
      } else {
        o[this.name] = this.value || '';
      }
    });
    return o;
  };

  //----------------------------------------------------------------------
  // Global Page Tracking
  //----------------------------------------------------------------------
  // External or mailto Link
  $('a').on('click', function (event) {

    var href = parseURL($(this).attr('href'));

    if (this.host !== window.location.host && href.protocol !== 'mailto:') {
      _trackAnalytics({
        'site_events': {
          'outbound_link_click': 'true'
        },
        'link_url': $(this).attr('href')
      });
    }

    if (href.protocol === 'mailto:') {
      _trackAnalytics({
        'site_events': {
          'email_link_click': 'true'
        },
        'email_address': href.pathname
      });
    }

  });

  if ($('body').hasClass('error404')) {
    _trackAnalytics({
      'site_events': {
        'page_not_found': 'true'
      },
      'page_url': window.location.href
    });
  }

  if ($('body').hasClass('home')) {
    var location = parseURL(window.location.href);
    if (parseInt(location.searchObject['gdpr_alumni_profile_registration']) === 1) {
      var trackingObj = {
        'site_events': {
          'alumni_profile_registration': 'true'
        },
      }
      _dl = Object.assign(trackingObj, _dl);
      // console.log(_dl);
    }
  }

  $('.faqs-more').on('click', function (e) {

    e.preventDefault();
    $('.faqs').toggleClass('faqs-showing-more');

  });

  $('.people--search-more').on('click', function (e) {

    e.preventDefault();
    $('.people--search-form').toggleClass('showing-more');

  });

  $('.people--search-results-refine-link').on('click', function (e) {

    e.preventDefault();
    $(this).parent().toggleClass('showing-content');

  });

  $('.applied-filters > a').on('click', function (e) {
    e.preventDefault();
    var curURL = window.location.href;
    var newURL = updateQueryStringParameter(window.location.href, $(this).attr('href'), '');
    window.location.href = newURL;
  });

  // Physician Activities
  if ($('body').hasClass('page-global-health-activities')) {

    var results = {};

    $('.btn-show-hide-description').on('click', function (event) {

      var $this = $(this);

      $this.closest('.card').find('.info-description').toggleClass('shown');
      $this.toggleClass('shown');

      if (!$this.hasClass('shown')) {
        $this.text($this.attr('data-show'));
      } else {
        $this.text($this.attr('data-hide'));
      }


    });

    $('.form-filter').on('submit', function (event) {
      event.preventDefault();

      var formData = $(this).serializeArray().reduce(function (obj, item) {

        if (item.value != -1) {
          if (obj[item.name] == null) {
            obj[item.name] = [];
          }
          obj[item.name].push(item.value);
        }

        return obj;

      }, {});

      function filterResults(activity) {

        var length = Object.keys(formData).length;
        var cnt = 0;

        for (var key in formData) {
          if (formData.hasOwnProperty(key)) {
            if (activity[key][0].includes(formData[key][0])) {
              cnt++;
            }
          }
        }

        // This needs to retun true or false
        // Checking for matchs in formData - if one key in formData it must match, if two keys they both must match
        return cnt == length;
      }
      var filteredResults = list.filter(filterResults);

      $('.card').addClass('hidden');
      $('.refer--message-no--results').removeClass('shown');

      if (filteredResults.length < 1) {
        $('.refer--message-no--results').addClass('shown');
      } else {
        for (var i = 0; i < filteredResults.length; i++) {
          $('#' + filteredResults[i].id).removeClass('hidden');
        }
      }


    })


    $('.btn-interested').on('click', function (event) {
      event.preventDefault();

      var $this = $(this);
      var $card = $this.closest('.card');
      var $additionalInformation = $card.find('.additional-information');

      $additionalInformation.addClass('active');
      $('.btn-interested').toggleClass('btn-hidden');
    });

    $("[name='choose-email']").change(function () {
      $('.input-preferred-email').toggleClass('active');
      $('.use-preferred-email').toggleClass('required');
    }).change();

    $('.additional-information-close').on('click', function (e) {
      $('.additional-information').toggleClass('active');
      $('.btn-interested').toggleClass('btn-hidden');
    });

    $('.submission-success-close').on('click', function (e) {
      $('.submission-success').toggleClass('active');
    });


    // Global var from PHP page
    // console.log(list);

    $('.physician-activities--message-form').on('submit', function (event) {
      event.preventDefault();

      // validate
      var errors = [];

      $(this).find('.required').each(function () {

        if ($(this).val().length < 1) {
          // show error
          errors.push($(this));
          $(this).siblings('.error').addClass('visible');
        } else {
          // hide error
          $(this).siblings('.error').removeClass('visible');
        }
      });

      if (errors.length > 0) {
        console.log(errors);
        return false;
      }

      var $this = $(this);
      var $card = $this.closest('.card');
      var data = new FormData();

      // lass="info-country"><
      // <p class="info-city">

      data.append("physicianEmail", $card.find('.info-email').text().trim());
      data.append("physicianCountry", $card.find('.info-country').text().trim());
      data.append("physicianCity", $card.find('.info-city').text().trim());
      data.append("interestStatement", $(this).find('textarea[name=interest-statement]').val());
      data.append("action", "message_physician_activity");
      data.append("crm_nonce", localized_object);

      if ($(this).find('#use-another-email').prop('checked')) {
        data.append("interestEmail", $(this).find('.use-preferred-email').val());
      } else {
        data.append("interestEmail", $(this).find('.use-stored-email').val());
      }

      $.ajax({
        type: "POST",
        url: localized_object.ajax_url,
        data: data,
        processData: false,
        contentType: false,
        timeout: 20000,
        beforeSend: function () {
          $('.refer--message').removeClass('shown');

          $card.addClass('sending');
        }
      })
        .done(function (response) {
          var res = JSON.parse(response);
          console.log(response);
          if (res[0].status == 'error') {
            $('.refer--message-error').addClass('shown');
            $('.refer--message-error').find('.message').text(res[1].results);
            $('html, body').animate({ scrollTop: 0 }, 'slow');
          } else {
            $('.refer--message-success .message').text(res[1].results);
            $('.submission-success').toggleClass('active');
            $card.find('.additional-information').removeClass('active');
          }

        })
        .fail(function (request, status, err) {
          console.log('REQUEST => ' + request);
          console.log('STATUS => ' + status);
          console.log('ERR => ');
          console.log(err);

          // $('.refer--message-error .message').text(response.results);
          // $('.refer--message-error').addClass('shown');
        }).always(function () {
          $card.removeClass('sending');
          $('.btn-interested').removeClass('btn-hidden');
        });
    });


    // --OLD VERSION
    // $('.cv-upload').on('change', function (event) {
    //   if ($(this)[0].files[0].name) {
    //     $(this).siblings('.cv-upload--file-label').text($(this)[0].files[0].name);
    //   }
    // });

    // --OLD VERSION
    // $('.physician-activities--message-form').on('submit', function (event) {

    //   event.preventDefault();

    //   // validate
    //   var errors = [];

    //   $(this).find('.required').each(function () {

    //     if ($(this).val().length < 1) {
    //       // show error
    //       errors.push($(this));
    //       $(this).siblings('.error').addClass('visible');
    //     } else {
    //       // hide error
    //       $(this).siblings('.error').removeClass('visible');
    //     }
    //   });

    //   if (errors.length > 0) {
    //     return false;
    //   }

    //   var $this = $(this);
    //   var $card = $this.closest('.card');
    //   var data = new FormData();

    //   data.append("name", $card.find('.info-name').text().trim())
    //   data.append("country", $card.find('.info-country').text().trim())
    //   data.append("city", $card.find('.info-city').text().trim())
    //   data.append("activity", $card.find('.info-activity').text().trim())
    //   data.append("specialty", $card.find('.info-specialty').text().trim())
    //   data.append("alumniSchool", $(this).find('textarea[name=school]').val())
    //   data.append("alumniGraduation", $(this).find('textarea[name=graduation]').val())
    //   data.append("alumniPosition", $(this).find('textarea[name=position]').val())
    //   data.append("alumniSpecialty", $(this).find('textarea[name=specialty]').val())


    //   if ($(this).find('input[type=file]')[0].files[0]) {
    //     data.append('file', $(this).find('input[type=file]')[0].files[0]);
    //   }
    //   data.append("action", "message_physician_activity");
    //   data.append("crm_nonce", localized_object);

    //   $.ajax({
    //     type: "POST",
    //     url: localized_object.ajax_url,
    //     data: data,
    //     processData: false,
    //     contentType: false,
    //     timeout: 20000,
    //     beforeSend: function () {
    //       $('.refer--message').removeClass('shown');

    //       $card.addClass('sending');
    //     }
    //   })
    //     .done(function (response) {
    //       var res = JSON.parse(response);

    //       if (res[0].status == 'error') {
    //         $('.refer--message-error').addClass('shown');
    //         $('.refer--message-error').find('.message').text(res[1].results);
    //       } else {
    //         $('.refer--message-success .message').text(res[1].results);
    //         $('.refer--message-success').addClass('shown');
    //         $card.find('.additional-information').removeClass('active');
    //       }

    //     })
    //     .fail(function (request, status, err) {
    //       console.log('REQUEST => ' + request);
    //       console.log('STATUS => ' + status);
    //       console.log('ERR => ');
    //       console.log(err);

    //       // $('.refer--message-error .message').text(response.results);
    //       // $('.refer--message-error').addClass('shown');
    //     }).always(function () {
    //       $card.removeClass('sending');
    //       $('html, body').animate({ scrollTop: 0 }, 'slow');
    //     });

    // });


  }


  //Refer A Patient
  if ($('body').hasClass('page-refer-a-friend')) {

    $('#DomesticInternational').on('change', function () {

      var selection = $(this).val();

      if (selection == 'Domestic') {

        $('#PatientCountry').val('United States');

      } else {

        $('#PatientCountry').val('');

      }

    });

    $('input.refer-form.button').on('click', function (event) {

      // delaying for submission to give time for the tracking call to be made
      event.preventDefault();

      _trackAnalytics({
        'site_events': {
          'patient_referral': 'true'
        },
        'referral_type': 'refer a friend'
      });

      var $that = $(this);
      setTimeout(function () {
        $that.closest('form').submit();
      }, 500);

    })
  }

  if ($('body').hasClass('page-refer-my-own-patient')) {

    $('.btn-refer-patient').on('click', function (event) {

      _trackAnalytics({
        'site_events': {
          'patient_referral': 'true'
        },
        'referral_type': 'refer patient'
      });

    })

  }


  $('body').on('added_to_cart', function () {

    $('.cart-contents-button').removeClass('empty');

  });


// Update Existing Email, Phone, Address
$('.profile-form').on('submit', function (e) {

    e.preventDefault();
    
    let thisForm = $(this);
    let alert = thisForm.parent().find("#alert");
    let submitButton = thisForm.find('input[type="submit"]');
    let formData = thisForm.serializeObject();
    
    formData.id = $('.id').val();
    formData.ContactId = $('.crm-data .ContactId').val();
    
    let ajaxData = {
        action: thisForm.attr('action'),
        crm_nonce: localized_object.nonce,
        data: formData
    };

    $.ajax({
        type: "POST",
        url: localized_object.ajax_url,
        data: ajaxData,
        dataType: "json",
        timeout: 20000,
        beforeSend: function () {
            submitButton.prop("disabled", true);
            submitButton.prop("disabled", true);
            thisForm.css({ 'cursor': 'wait' });
            thisForm.find('input, a, select, label').css({ 'cursor': 'wait' });
            alert.text('');
            alert.removeClass('alert-danger');
            alert.removeClass('alert-success');
            alert.addClass('hidden');
        }
    })
    .done(function (response) {

        console.log(response);

        if (thisForm.hasClass('profile-form-password')) {

            window.location.replace("/login/");

        } else if (response.error || (typeof response.data.updateContactData !== "undefined" && response.data.updateContactData.indexOf('error') > 0)) {
          // show error text

            let errorMessage = response.error ? response.error : 'Something went wrong';
            
            alert.text(errorMessage);
            alert.addClass('alert-danger');
            alert.removeClass('hidden');

        // } else if( response.data.updateContactData.replace(/['"]+/g, '').match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$') ) {
        } else if (response.data.updateContactData || response.data.addPhone) {

            alert.text('data successfully added.');
            alert.addClass('alert-success');
            alert.removeClass('hidden');

            //window.location.reload();

            // Reset form

            // thisForm.closest('.my-profile-form').toggleClass('is-visible');
            // thisForm[0].reset();

            // Add address to list without refreshing page
            // var listItem = createNewListItem('', formDataString, thisForm.attr('action'));
            // if (listItem) {
            //   thisForm.parent().parent().find('.my-profile-list').append(listItem);
            // }

        } else {
            // server error or other error (Please check all fields and try again.)

            alert.text("Something went wrong. Please check all fields and try again.");
            alert.addClass('alert-danger');
            alert.removeClass('hidden');
        }

    })
    .fail(function (request, status, err) {

        console.log('REQUEST => '); console.log(request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

    })
    .always(function () {

        submitButton.prop("disabled", false);
        thisForm.css({ 'cursor': 'auto' });
        thisForm.find('input, a, select, label').css({ 'cursor': 'auto' });

    });
});

  function validateAddressForm(form) {

    // If business address Company Name field is required
    if (form.find('.AddressTypeName option:selected').text() == 'Business') {

      if (form.find('.settings-address-company-name input').val().length < 1) {
        form.find('.settings-address-company-name').addClass('not-valid');
        return false;
      } else {
        $('.settings-address-company-name').removeClass('not-valid');
        return true;
      }
    }

    // If seasonal address Start Month and End Month are required
    if (form.find('.AddressTypeName option:selected').text() == 'Seasonal') {

      var $startMonth = form.find('.settings-address-start-month');
      var $endMonth = form.find('.settings-address-end-month');
      var fields = [$startMonth, $endMonth];
      var validFields = $.extend(true, [], fields);

      for (var i = 0; i < fields.length; i++) {

        var $field = fields[i];

        if ($field.find('select').val().length < 1) {
          $field.addClass('not-valid');
        } else {
          $field.removeClass('not-valid');
          validFields.splice(0, 1);
        }
      }

      if (validFields.length > 0) {
        return false;
      } else {
        return true;
      }
    }

  }

  // New Address
  // $('.profile-form').on('submit', function (e) {
  //
  //   e.preventDefault();
  //
  //   var thisForm = $(this);
  //   var submitButton = thisForm.find('input[type="submit"]');
  //   var formData = thisForm.serializeObject();
  //   var formDataString = formData[Object.keys(formData)[0]];
  //   formData.id = $('.id').val();
  //   formData.ContactId = $('.crm-data .ContactId').val();
  //   formData.Address1StateProvinceId = $('.crm-data .Address1StateProvinceId').val();
  //   formData.Address1StateProvinceId = $('.crm-data .Address1StateProvinceId').val();
  //   formData.Address1CountryId = $('.crm-data .Address1CountryId').val();
  //   formData.Address1TypeId = $('.crm-data .Address1TypeId').val();
  //   formData.Address1CompanyName = $('.crm-data .Address1CompanyName').val();
  //
  //   if (thisForm.hasClass('profile-form-email')) {
  //
  //     var emailAddress = $('#AddEmailAddress').val();
  //
  //     if (formData.EmailAddressPrimary) {
  //       formData.PrimaryEmail = emailAddress;
  //     } else {
  //       formData.SecondaryEmail = emailAddress;
  //     }
  //
  //     delete formData.EmailAddress;
  //
  //   }
  //
  //   if (thisForm.hasClass('profile-form-phone')) {
  //
  //     var phone1 = $('#PrimaryPhone').val();
  //     //var phone1Type = $('#Phone1').attr('name');
  //
  //     var phone2 = $('#SecondaryPhone').val();
  //     //var phone2Type = $('#Phone2').attr('name');
  //
  //     // if (formData.PhoneType == 'Telephone1') {
  //     //   formDataString = '<label class="my-profile-list-item-label" for="Telephone1">Business:</label> ';
  //     // } else if (formData.PhoneType == 'TelePhone2') {
  //     //   formDataString = '<label class="my-profile-list-item-label" for="TelePhone2">Home:</label> ';
  //     // } else if (formData.PhoneType == 'MobilePhone') {
  //     //   formDataString = '<label class="my-profile-list-item-label" for="MobilePhone">Mobile:</label> ';
  //     // }
  //     //
  //     // formDataString += formData.Phone;
  //     // // formDataString += formData.Phone2;
  //     //
  //     // if (formData.PreferredPhoneNumber) {
  //     //
  //     //   if (formData.PhoneType == 'Telephone1') {
  //     //     formData.PreferredPhoneNumber = 100000001;
  //     //   } else if (formData.PhoneType == 'TelePhone2') {
  //     //     formData.PreferredPhoneNumber = 100000000;
  //     //   } else if (formData.PhoneType == 'MobilePhone') {
  //     //     formData.PreferredPhoneNumber = 100000002;
  //     //   }
  //     //
  //     //   formDataString += ' <small>Preferred</small>';
  //     //   thisForm.parent().parent().find('small').remove();
  //     //
  //     // } else {
  //     //   formData.PreferredPhoneNumber = $('.PreferredPhoneNumber').val();
  //     // }
  //
  //     if (phone1) {
  //       formData['Telephone1'] = phone1;
  //     }
  //
  //     if (phone2) {
  //       formData['Telephone2'] = phone2;
  //     }
  //
  //     //formData[formData.PhoneType] = formData.Phone;
  //
  //
  //   }
  //
  //   if (thisForm.hasClass('profile-form-address')) {
  //
  //     var addressRecordType = '';
  //
  //     switch (formData.OverwriteParentRecordsAddressName) {
  //       case "Overwrite Address 1 (preferred mail to)":
  //         addressRecordType = 'Primary';
  //         break;
  //       case "Overwrite Address 2":
  //         addressRecordType = 'Secondary';
  //         break;
  //     }
  //
  //     formDataString = '<small>' + formData.AddressTypeName + ' Address &ndash; ' + addressRecordType + '</small><br/>';
  //     formDataString += formData.Street1 + '<br />' + formData.Street2 + '<br/>';
  //     formDataString += formData.City + ', ' + formData.StateID + ' ' + formData.ZipPostalCode;
  //
  //     formData[formData.PhoneType] = formData.Phone;
  //
  //   }
  //
  //   if (thisForm.hasClass('profile-form-professional-organizations')) {
  //     formDataString = formData.ProfessionalOrganizationName ? '<label class="my-profile-list-item-label">Name:</label> ' + formData.ProfessionalOrganizationName : '';
  //     formDataString += formData.ProfessionalOrganizationName && formData.Role ? '<br/>' : '';
  //     formDataString += formData.Role ? '<label class="my-profile-list-item-label">Role:</label> ' + formData.Role : '';
  //   }
  //
  //   if (thisForm.hasClass('profile-form-other-education')) {
  //     formDataString = '<label class="my-profile-list-item-label">School Name: </label> ' + formData.Name + '<br/>';
  //     formDataString += '<label class="my-profile-list-item-label">Degree: </label> ' + formData.ProgramDescription + '<br/>';
  //     formDataString += '<label class="my-profile-list-item-label">Specialty: </label> ' + formData.OtherSpeciality + '<br/>';
  //     year = formData.RoleEndDate.split("/");
  //     year = typeof year[2] !== 'undefined' ? year[2].substring(0, 4) : year[0];
  //     formData.Name = formData.Name ? formData.Name : 'Unspecified';
  //     formDataString += '<label class="my-profile-list-item-label">Year: </label> ' + year;
  //   }
  //
  //   formData['PrimaryOrSecondary'] = 'null';
  //   if (thisForm.find("input[name='OverwriteParentRecordsAddressName']:checked").attr('data-priority')) {
  //
  //     switch (thisForm.find("input[name='OverwriteParentRecordsAddressName']:checked").attr('data-priority')) {
  //       case 'Primary':
  //         formData['PrimaryOrSecondary'] = 'P';
  //         break;
  //       case 'Secondary':
  //         formData['PrimaryOrSecondary'] = 'S';
  //         break;
  //     }
  //   }
  //
  //
  //   formData['Telephone1'] = phone1;
  //   formData['Telephone2'] = phone2;
  //
  //   var ajaxData = {
  //     action: thisForm.attr('action'),
  //     crm_nonce: localized_object.nonce,
  //     data: formData
  //   };
  //
  //   var alert = thisForm.parent().find('#alert');
  //
  //    $.ajax({
  //     type: "POST",
  //     url: localized_object.ajax_url,
  //     data: ajaxData,
  //     dataType: "json",
  //     timeout: 20000,
  //     beforeSend: function () {
  //       submitButton.prop("disabled", true);
  //       thisForm.css({ 'cursor': 'wait' });
  //       thisForm.find('input, a, select, label').css({ 'cursor': 'wait' });
  //
  //       alert.text('');
  //       alert.removeClass('alert-danger');
  //       alert.removeClass('alert-success');
  //       alert.addClass('hidden');
  //     }
  //   })
  //     .done(function (response) {
  //
  //       if (thisForm.hasClass('profile-form-password')) {
  //         window.location.replace("/login/");
  //
  //       } else if(response.error) {
  //         // show error text
  //
  //         alert.text(response.error);
  //         alert.addClass('alert-danger');
  //         alert.removeClass('hidden');
  //
  //
  //       // } else if( response.data.updateContactData.replace(/['"]+/g, '').match('^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$') ) {
  //         } else if( response.data.updateContactData) {
  //
  //
  //           alert.text('data successfully added.');
  //           alert.addClass('alert-success');
  //           alert.removeClass('hidden');
  //
  //           window.location.reload();
  //
  //         // Reset form
  //
  //         // thisForm.closest('.my-profile-form').toggleClass('is-visible');
  //         // thisForm[0].reset();
  //
  //         // Add address to list without refreshing page
  //         var listItem = createNewListItem('', formDataString, thisForm.attr('action'));
  //         if (listItem) {
  //           thisForm.parent().parent().find('.my-profile-list').append(listItem);
  //         }
  //
  //       } else {
  //         // server error or other error (Please check all fields and try again.)
  //
  //         alert.text("Something went wrong. Please check all fields and try again.");
  //         alert.addClass('alert-danger');
  //         alert.removeClass('hidden');
  //       }
  //       window.location.reload();
  //
  //     })
  //
  //     .fail(function (request, status, err) {
  //
  //       console.log('REQUEST => '); console.log(request);
  //       console.log('STATUS => ' + status);
  //       console.log('ERR => ');
  //       console.log(err);
  //
  //     }).always(function () {
  //
  //       submitButton.prop("disabled", false);
  //       thisForm.css({ 'cursor': 'auto' });
  //       thisForm.find('input, a, select, label').css({ 'cursor': 'auto' });
  //
  //     });
  //
  // });

  function createNewListItem(type, value, action) {

    var output = '';

    output += '<li class="my-profile-list-item my-profile-list-item__new-item"><span class="my-profile-list-item-current-values"><span>' + value + '</span></span></li>';

    return output;

  }

  $('.add-profile-info').on('click', function (e) {

    e.preventDefault();
    $(this).parent().next().toggleClass('is-visible');

  });

  $('.AddressTypeName').on('change', function () {

    if ($(this).val() == 'Business') {
      $(this).closest('form').find('.settings-address-company-name').show();
      $(this).closest('form').find('.settings-address-start-month').hide();
      $(this).closest('form').find('.settings-address-end-month').hide();
    } else if ($(this).val() == 'Seasonal') {
      $(this).closest('form').find('.settings-address-company-name').hide();
      $(this).closest('form').find('.settings-address-start-month').show();
      $(this).closest('form').find('.settings-address-end-month').show();
    } else {
      $(this).closest('form').find('.settings-address-company-name').hide();
      $(this).closest('form').find('.settings-address-start-month').hide();
      $(this).closest('form').find('.settings-address-end-month').hide();
    }

  });


  $('.profile-form-toggle').on('click', function(e) {

    e.preventDefault();
    $(this).closest('.my-profile-form').toggleClass('is-visible');

  });

  $('.my-profile-section, .settings-section').on('click', '.edit-profile-list-item', function (e) {

    e.preventDefault();
    $(this).parent().parent().toggleClass('show-form');

  });

  $('.my-profile-section, .settings-section').on('click', '.my-profile-list-item-form-cancel', function (e) {

    e.preventDefault();
    $(this).closest('.my-profile-list-item').removeClass('show-form');

  });




  $('.mentor-delete-residency').on('click', function (e) {

    e.preventDefault();

    var thisForm = $(this);
    var formData = { "post": $(this).attr('data-post') };
    formData.id = $('.id').val();

    var ajaxData = {
      action: 'remove_mentorship_residency',
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        //   $('.privacy-radio-input').prop("disabled", true);
      }
    })
      .done(function (response) {
        location.reload();
      })
      .fail(function (request, status, err) {
        // console.log( 'REQUEST => ' + request );
        // console.log( 'STATUS => ' + status );
        console.log('ERR => ');
        console.log(err);
        console.log(request);
        console.log(status);
      }).always(function () {
        // $('.privacy-radio-input').prop("disabled", false);
      });
  });

  $('#mayo_alumni_mentor_enrollment_remove').on('click', function (e) {

    e.preventDefault();

    var thisForm = $(this);
    var formData = {};
    formData.id = $('.id').val();

    $('#mentorship-enrollment-form :input').each(function (index) {
      formData[this.name] = $(this).val();
    });

    var ajaxData = {
      action: 'remove_mentorship_status',
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        $('#mentorship-enrollment-form').css({ 'opacity': 0.5 });
        $('.input-row').find('input').prop('disabled', true);
        $('.select-dropdown').find('select').prop('disabled', true);
        $('textarea').prop('disabled', true);
      }
    })
      .done(function (response) {

        var url = window.location.href.split(/[?#]/)[0];
        window.location.href = url + '?status=removed';
      })
      .fail(function (request, status, err) {
        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

        $('#mentorship-enrollment-form').css({ 'opacity': 1 });
        $('.input-row').find('input').prop('disabled', false);
        $('.select-dropdown').find('select').prop('disabled', false);
        $('textarea').prop('disabled', true);

      }).always(function () {
        // $('.privacy-radio-input').prop("disabled", false);
      });

  });

  $('#mentorship-enrollment-form').on('submit', function (e) {
    e.preventDefault();

    var thisForm = $(this);
    var formData = thisForm.serializeObject();
    formData['mayo_alumni_mentor_enrollment'] = true;
    formData.id = $('.id').val();

    // validate
    var errors = [];
    $(this).find('.required').each(function () {
      if ($(this).val().length < 1) {
        // show error
        errors.push($(this));
        $(this).siblings('.error').addClass('visible');
        $(this).parent().siblings('.error').addClass('visible');
      } else {
        // hide error
        $(this).siblings('.error').removeClass('visible');
        $(this).parent().siblings('.error').removeClass('visible')
      }
    });

    if (errors.length > 0) {
      return false;
    }

    var residencyData;
    formData.residencies = [];

    // TODO: move and format template into script tag
    // exclude template from data
    $('#residency-input-template :input').each(function (index) {
      delete formData[this.name];
    });


    $('.residency-input').each(function (index) {

      var residency = {};

      $(this).find(':input').each(function () {
        residency[this.name] = $(this).val();
        delete formData[this.name];
      })

      formData.residencies.push(residency);
    });

    var ajaxData = {
      action: 'update_mentorship_status',
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        // show loader
        $('#mentorship-enrollment-form').css({ 'opacity': 0.5 });
        $('.input-row').find('input').prop('disabled', true);
        $('.select-dropdown').find('select').prop('disabled', true);
        $('textarea').prop('disabled', true);
      }
    })
      .done(function (response) {

        var url = window.location.href.split(/[?#]/)[0];
        window.location.href = url + '?status=signed-up';
      })
      .fail(function (request, status, err) {
        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

        $('#mentorship-enrollment-form').css({ 'opacity': 1 });
        $('.input-row').find('input').prop('disabled', false);
        $('.select-dropdown').find('select').prop('disabled', false);
        $('textarea').prop('disabled', false);

      }).always(function () {
        // $('.privacy-radio-input').prop("disabled", false);
      });

  });


  $('.privacy-radio-input').on('change', function (e) {

    e.preventDefault();

    var thisInput = $(this);
    var thisInputVal = (thisInput.attr('type') === 'radio') ? ($(this).is(':checked')) ? thisInput.attr('data-privacy-val') : 2 : thisInput.val();

    var formData = {};
    formData.mayo_alumni_profile_privacy = thisInputVal;
    formData.id = $('.id').val();
    formData.ContactId = $('.crm-data .ContactId').val();

    if (thisInputVal == 3) {
      $('#mayo_alumni_profile_privacy_1').prop('checked', false);
      $('.js-privacy-mccn-checkbox').prop('checked', false);
      formData.mayo_alumni_mccn_privacy = false;
    }

    var ajaxData = {
      action: 'put_crm_alumni_privacy',
      crm_nonce: localized_object.nonce,
      data: formData,
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        $('input').prop("disabled", true);
      }
    })
    .done(function (response) {

        if (thisInputVal == 3) {
          $('#mayo_alumni_profile_privacy_1').parent().parent().addClass('blocked');
        } else {
          $('#mayo_alumni_profile_privacy_1').parent().parent().removeClass('blocked');
        }

    })
    .fail(function (request, status, err) {

        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

    }).always(function (data) {
        $('input').prop('disabled', false);
    });

  });
  
  $('.privacy-checkbox-input').on('change', function (e) {

    e.preventDefault();

    let formData = {
        databaseField: $(this).attr('id'),
        dataVal:       $(this).is(':checked'),
        id:            $('.id').val(),
        ContactId:     $('.crm-data .ContactId').val(),
        crmField:      $(this).attr('name'),
    }

    let ajaxData = {
        action: 'put_crm_alumni_privacy',
        crm_nonce: localized_object.nonce,
        data: formData,
    };

    $.ajax({
        type: "POST",
        url: localized_object.ajax_url,
        data: ajaxData,
        dataType: "json",
        timeout: 20000,
        beforeSend: function () {
          $('input').prop("disabled", true);
        }
    })
    .done(function (response) {

        $('input').prop("disabled", false);

    })
    .fail(function (request, status, err) {

        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

    }).always(function (data) {
        $('input').prop('disabled', false);
    });

  });


  $('.js-privacy-mccn-checkbox').on('change', function (e) {

    var $this = $(this);
    var formData = {};

    formData.id = $this.attr('data-id');
    formData.mayo_alumni_mccn_privacy = $this.is(':checked');

    var ajaxData = {
      action: 'update_mccn_privacy',
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        $('input').prop("disabled", true);
      }
    })
      .done(function (response) {

      })
      .fail(function (request, status, err) {
        console.log('REQUEST => ', request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
      }).always(function () {
        $('input').prop("disabled", false);
      });


  });


  $('.js-privacy-mccn-checkbox').on('change', function (e) {

    var $this = $(this);
    var formData = {};

    formData.id = $this.attr('data-id');
    formData.mayo_alumni_mccn_privacy = $this.is(':checked');

    var ajaxData = {
      action: 'update_mccn_privacy',
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        $('input').prop("disabled", true);
      }
    })
      .done(function (response) {

      })
      .fail(function (request, status, err) {
        console.log('REQUEST => ', request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
      }).always(function () {
        $('input').prop("disabled", false);
      });


  });
  
  // Update Other Education, Fields of Practice, and Professional Organizations
  $('.my-profile-add-list-form').on('submit', function (e) {

      e.preventDefault();
    
      let thisForm = $(this);
      let submitButton = thisForm.find('input[type="submit"]');
      let formData = thisForm.serializeObject();
    
      formData.id = $('.id').val();
      formData.ContactId = $('.crm-data .ContactId').val();
    
      let ajaxData = {
          action: thisForm.attr('action'),
          crm_nonce: localized_object.nonce,
          data: formData
      };
    
      myProfileAddListFormAjax( thisForm, submitButton, formData, ajaxData, true );
    
  });
  
  function myProfileAddListFormAjax( thisForm, submitButton, formData, ajaxData, reloadPage ) {
      $.ajax({
          type: "POST",
          url: localized_object.ajax_url,
          data: ajaxData,
          dataType: "json",
          timeout: 20000,
          beforeSend: function () {
              
              submitButton.prop("disabled", true);
              submitButton.prop("disabled", true);
              thisForm.css({ 'cursor': 'wait' });
              thisForm.find('input, a, select, label').css({ 'cursor': 'wait' });
              
          }
      })
      .done(function (response) {

          if(reloadPage) {
              window.location.reload(true);
          }

      })
      .fail(function (request, status, err) {

          console.log('REQUEST => '); console.log(request);
          console.log('STATUS => ' + status);
          console.log('ERR => ');
          console.log(err);

      })
      .always(function () {

          submitButton.prop("disabled", false);
          thisForm.css({ 'cursor': 'auto' });
          thisForm.find('input, a, select, label').css({ 'cursor': 'auto' });

      });
  }
  
  // Update Other Education, Fields of Practice, and Professional Organizations
  $('.my-profile-section, .settings-section').on('click', '.my-profile-delete-list-item', function (e) {
      
    e.preventDefault();

    let formData = {};
    let dataAction = '';

    formData.FieldOfPracticeId = $(this).attr('data-id');
    
    dataAction = $(this).attr('data-action');

    let ajaxData = {
        action: dataAction,
        crm_nonce: localized_object.nonce,
        data: formData
    };

    myProfileDeleteListItem( formData, dataAction, ajaxData );
    
  });
  
  function myProfileDeleteListItem( formData, dataAction, ajaxData ) {
      
      $.ajax({
          type: "POST",
          url: localized_object.ajax_url,
          data: ajaxData,
          dataType: "json",
          timeout: 20000,
          beforeSend: function () {
              
              $('input').prop("disabled", true);
              
          }
      })
      .done(function (response) {
          
          window.location.reload(true);
          
      })
      .fail(function (request, status, err) {
          
          console.log('REQUEST => ', request);
          console.log('STATUS => ' + status);
          console.log('ERR => ');
          
      }).always(function () {
          
          $('input').prop("disabled", false);
          
      });
  }
  
  // Update Other Education, Fields of Practice, and Professional Organizations
  $('.profile-form-add-fields-of-practice').on('submit', function (e) {

      e.preventDefault();
    
      let thisForm = $(this);
      let submitButton = thisForm.find('input[type="submit"]');
      let formData = thisForm.serializeObject();
      
      formData.ContactId = $('.crm-data .ContactId').val();
    
      let ajaxData = {
          action: thisForm.attr('action'),
          crm_nonce: localized_object.nonce,
          data: formData
      };
    
      myProfileAddListFormAjax(thisForm, submitButton, formData, ajaxData, false);
      
      // click the delete link
      thisForm.find('.my-profile-delete-list-item').click();
      
  });

  $('.my-profile-section, .settings-section').on('click', '.my-profile-delete-record', function (e) {

    e.preventDefault();

    if (!$(this).data('keys')) return;


    var thisSection = $(this).closest('.show-form');
    var thisForm = $(this).closest('form');
    var formData = {};
    var action = $(this).data('action') ? $(this).data('action') : 'delete_profile_meta';
    formData.keys = $(this).data('keys') ? $(this).data('keys').split(',') : '';
    formData.values = $(this).data('values');

    formData.id = $('.id').val();
    formData.ContactId = $('.crm-data .ContactId').val();

    $.each(formData.keys, function (index, value) {

      formData[value] = Array.isArray(formData.values) ? formData.values[index] : '';

    });

    var ajaxData = {
      action: action,
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        thisForm.find('input').prop("disabled", true);
      }
    })
      .done(function (response) {

        if (response) {
          if (formData.keys[0] == 'mayo_alumni_photo') {
            $('.update-profile-pic').css('background-image', 'url(/wp-content/themes/mayo-alumni/assets/img/user-default.gif)');
          }
        }

      })
      .fail(function (request, status, err) {

        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

      }).always(function () {

        thisForm.find('input').prop("disabled", false);

        if (formData.keys[0] == 'mayo_alumni_photo') {
          thisSection.toggleClass('show-form');
        } else {
          thisSection.remove();
        }

      });

  });

  $('.update-profile-pic').on('click', function (e) {
    e.preventDefault();
    $(this).parent().toggleClass('show-form');
  });

  $('.profile-form-photo .my-profile-list-item-form-cancel').on('click', function (e) {
    e.preventDefault();
    $('.my-profile-personal-photo').toggleClass('show-form');
  });

  $('.my-profile-is-retired').on('change', function (e) {

    e.preventDefault();

    var thisInput = $(this);
    var thisInputVal = $(this).is(':checked') ? thisInput.val() : 'No';
    var formData = {};
    formData['mayo_alumni_profile_is_retired'] = thisInputVal;
    formData.Id = $('.ContactId').val();
    formData.update = $('.my-profile-is-retired-update').val();

    var ajaxData = {
      action: 'put_crm_alumni_is_retired',
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        $('.my-profile-is-retired').prop("disabled", true);
      }
    })
      .done(function (response) {

        //
        if (response) {
          $('.my-profile-is-retired-update').val(thisInputVal);
        }

      })
      .fail(function (request, status, err) {

        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

      }).always(function () {

        $('.my-profile-is-retired').prop("disabled", false);

      });

  });



  $('.my-profile-is-mfa-member').on('change', function (e) {

    e.preventDefault();

    var thisInput = $(this);
    var thisInputVal = $(this).is(':checked') ? thisInput.val() : 'No';
    var formData = {};
    formData['mayo_alumni_profile_fma_member'] = thisInputVal;
    formData.id = thisInput.attr('data-id')
    formData.update = $('.my-profile-is-retired-update').val();

    var ajaxData = {
      action: 'mfa_alumni_is_member',
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {

      }
    })
      .done(function (response) {

        //  console.log(response)

      })
      .fail(function (request, status, err) {

        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

      }).always(function () {

      });

  });




  $('.my-profile-allow-contact').on('change', function (e) {

    e.preventDefault();

    var thisInput = $(this);
    var thisInputVal = $(this).is(':checked') ? thisInput.val() : 'No';
    var formData = {};
    formData['mayo_alumni_profile_allow_contact'] = thisInputVal;
    formData.id = $('.id').val();
    formData.update = $('.my-profile-allow-contact-update').val();

    var ajaxData = {
      action: 'update_profile',
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        $('.my-profile-allow-contact').prop("disabled", true);
      }
    })
      .done(function (response) {
        if (response) {
          $('.my-profile-allow-contact-update').val(thisInputVal);
        }

      })
      .fail(function (request, status, err) {

        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

      }).always(function () {

        $('.my-profile-allow-contact').prop("disabled", false);

      });

  });


  $('.connect-checkbox').on('change', function () {

    var checkbox = $(this);

    var ajaxData = {
      action: 'update_profile_connect_options',
      data: {
        id: $('.id').val(),
        is_checked: checkbox.attr('checked') ? 1 : 0,
        value: checkbox.val()
      }
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        checkbox.prop("disabled", true);
      }
    })
      .done(function (response) {
        checkbox.removeProp("disabled");
      })
      .fail(function (request, status, err) {

        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

      }).always(function () {
        checkbox.removeProp("disabled");
      });

  });

  $('.people--search-results-refine-p').on('click', function () {
    $(this).parent().toggleClass('showing-filters');
  });

  $('.my-profile-personal-bio-form').on('submit', function (e) {
    e.preventDefault();

    var thisForm = $(this);
    var thisButton = $(this).find('button');
    var formData = thisForm.serializeObject();
    formData.id = $('.id').val();
    var ajaxData = {
      action: thisForm.attr('action'),
      data: formData
    };

    var ajaxData = {
      action: ajaxData.action,
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        thisForm.addClass('is-submitting');
        thisButton.prop("disabled", true);
      }
    })
      .done(function (response) {
        thisForm.removeClass('is-submitting');
        thisButton.removeProp("disabled");
      })
      .fail(function (request, status, err) {

        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);

      }).always(function () {

        $('.my-profile-allow-contact').prop("disabled", false);

      });

  });


  if ($('.quanity-input').length > 0) {

    var quanityInput = $('.qty');

    $('.decrease-quanity').on('click', function (event) {
      event.preventDefault();
      var curVal = parseInt(quanityInput.val());
      var newVal = curVal > 1 ? curVal - 1 : 1;
      console.log(newVal);
      quanityInput.val(newVal);
    });

    $('.increase-quanity').on('click', function (event) {
      event.preventDefault();
      var curVal = parseInt(quanityInput.val());
      var newVal = curVal + 1;
      quanityInput.val(newVal);
    });

  }

  if ($('#content').length > 0 && $('.post.single').length > 0) {

    var $container = $('#content');

    $container.imagesLoaded(function () {

      $container.masonry({

        columnWidth: function () {
          return this.size.innerWidth / 4;
        },
        itemSelector: ".post"

      });

      $('.post').css('visibility', 'visible');

    });

  }

  if ($(".stretch").length > 0) {
    $(".stretch").not('.map').anystretch();
  }

  if ($(".map").length > 0) {
    $(".map.stretch").anystretch('',
      {
        positionX: 'left',
        positionY: 'center'
      });
  }

  if ($("#cat").length > 0) {
    console.log('cat hit!');
    $("#cat").on('change', function () {
      var catID = $(this).val() > 0 ? "/?cat=" + $(this).val() : '/news/';
      window.location.href = localized_object.base_url + catID;
    });
  }

  if ($('.article-slideshow').length > 0) {

    $('.article-slideshow-image').on('click', function () {

      var slideID = $(this).data('slide-id');
      var parent = $(this).parent();
      var nextSlide = $(this).next('.article-slideshow-image').length > 0 ? $(this).next('.article-slideshow-image') : parent.find('.article-slideshow-image:first-child');
      var nextSlideID = nextSlide.data('slide-id');

      nextSlide.addClass('active');
      $(this).removeClass('active');

      $('#article-slide-paginator-' + nextSlideID).addClass('active');
      $('#article-slide-paginator-' + slideID).removeClass('active');

    });

  }

  if ($('body').hasClass('page-settings')) {

    $(".autocomplete").autocomplete({
      source: window.states,
      change: function (event, ui) {

        var element = event.currentTarget.id;

        if (ui.item == null || ui.item == undefined) {

          var txtSearchProNum = $("#" + element);
          txtSearchProNum.val("");

        }

      }

    });

  }

  if ($('#password-reveal').length > 0) {

    var new_input = '';

    $('#password-reveal').on('click', function (event) {
      event.preventDefault();

      var input = $(this).prev();
      var input_type = input.attr('type');
      var input_val = input.val();

      if (input_type == 'text') {

        new_input = '<input type="password" value="' + input_val + '" name="password" id="password" class="input-text" />';
        $(this).text('Reveal');

      } else {

        new_input = '<input type="text" value="' + input_val + '" name="password" id="password" class="input-text" />';
        $(this).text('Hide');

      }

      input.remove();
      $(this).before($(new_input));

    });

  }

  $('[data-toggle="tooltip"]').tooltip({
    'html': true,
    'animation': false,
    'trigger': 'click hover'
  }).on('click', function (event) {
    event.preventDefault();
  });


  $(document).on('found_variation', 'form.variations_form', function (event, variation) {

    var variation_description = variation.variation_description ? variation.variation_description : "";

    if ($('.single_variation_description').length > 0 && variation.variation_description) {
      $('.single_variation_description').html('<h4>Product Description:</h4><p>' + variation_description + '</p>');
    } else if (variation.variation_description) {
      $('.variations_button_wrap').after('<div class="single_variation_description"><h4>Product Description:</h4><p>' + variation.variation_description + '</p></div>');
    } else {
      $('.single_variation_description').remove();
    }

  });

  $('form.variations_form .variations select').trigger('change');


});

var WooCommerce = {

  init: function () {

    WooCommerce.eventListeners();

  },

  eventListeners: function () {

  }

};

$(function () {
  WooCommerce.init();
});

// var Overlay = {
//
//   init: function () {
//
//     if ($('body').hasClass('overlay-active')) {
//
//       Overlay.setSize();
//       Overlay.eventListeners();
//
//     }
//
//   },
//
//   eventListeners: function () {
//
//     $(window).resize(function () {
//       Overlay.setSize();
//     });
//
//     $('.overlay-content-close, .overlay-background, .overlay-close-btn ').on('click', function (event) {
//       event.preventDefault();
//       Overlay.close();
//     });
//
//   },
//
//   close: function () {
//     $('body').removeClass('overlay-active');
//     $('.overlay').remove();
//   },
//
//   setSize: function () {
//
//     var el = $('.overlay-content');
//     var elHeight = el.outerHeight();
//     var winHeight = $(window).height();
//
//     if (elHeight >= winHeight) {
//       var newHeight = winHeight / 10;
//       el.css({
//         'height': (newHeight * 8) + 'px',
//         'top': ((winHeight / newHeight)) + '%'
//       });
//     } else {
//       var diff = Math.round((((winHeight - elHeight) / 2) / winHeight) * 100 - 1);
//       el.css({
//         'height': 'auto',
//         'top': diff + '%'
//       });
//     }
//
//   }
//
// };

// $(function () {
//   Overlay.init();
// });

var App = {

  init: function () {

    App.eventListeners();

  },

  eventListeners: function () {

  }

};

$(function () {
  App.init();
});

var ProcessFormData = {

  formDataString: function (form) {

    var output = '';

    switch (form) {
      case "profile-form-phone":
        output = '';
        break;
      case "profile-form-phone":
        output = '';
        break;
      default:
        output = '';
    }

    return output;

  }

};


var Mentorship = (function () {

  var residencyIndex = 0;

  var init = function init() {
    _addListeners();

    // if no residecies exist, inset residency preview template
    if ($('.mentorship-preview ul').children().length < 1) {
      $('.add-mentorship-residency').trigger('click');
    }

    $('.mentor-profile').trigger('input');

  }

  var _addListeners = function _addListeners() {

    // to move preview element down with scroll
    $(window).scroll(function (e) {
      var $el = $('.mentorship-preview');
      var isPositionFixed = ($el.css('position') == 'fixed');

      if ($(this).scrollTop() > $el.parent('.row').offset().top && !isPositionFixed && !_previewAboveForm()) {
        $el.removeClass('fixed-bottom');
        $el.addClass('fixed');
      }

      if (_previewAboveForm()) {
        $el.addClass('fixed-bottom');
        $el.removeClass('fixed');
      } else {
        $el.removeClass('fixed-bottom');
      }

      if ($(this).scrollTop() < $el.parent('.row').offset().top && isPositionFixed || _previewAboveForm()) {
        $el.removeClass('fixed');
        $el.removeClass('fixed-bottom');
      }

    });

    $('.page-mentorship').on('input', '.mentor-profile', _onMentorChange);
    $('.page-mentorship').on('change keyup keydown', '#Speciality', _onMentorChange);
    $('body').on('mouseup', '.ui-autocomplete li', _onMentorChange);


    $('.add-mentorship-residency').on('click', _onAddMentorshipClick);
    $('#mentorship-enrollment-form').on('click', '.button-residency-cancel', _onResidencyCancelClick);
  }

  var _previewAboveForm = function _previewAboveForm() {

    var $el = $('.mentorship-preview');

    if (($el.offset().top + $el.outerHeight() + 20) > ($el.parent('.row').offset().top + $el.parent('.row').outerHeight()) && $el.offset().top > $el.parent('.row').offset().top) {
      return true;
    } else {
      return false;
    }

  }

  //----------------------------------------------------------------------
  // Form Event Handlers
  //----------------------------------------------------------------------
  var _onMentorChange = function _onMentorEmailChange(event) {

    // If autocomplete use #Speciality data-attr
    var $previewField = ($(this).hasClass('mentor-profile')) ? $('#' + $(this).attr('data-preview')) : $('#' + $('#Speciality').attr('data-preview'));

    var text = ($(this).hasClass('mentor-profile')) ? $(this).val() : $(this).text();
    $previewField.text(text);
  }

  var _onAddMentorshipClick = function _onAddMentorshipClick(event) {

    event.preventDefault();

    var $residency = $('#residency-input-template').clone().removeAttr('id').addClass('residency-input');

    // increment data-preview attr to allow for multiple residency previews
    $residency.find(':input').each(function () {
      var attr = $(this).attr('data-preview') + residencyIndex;
      $(this).attr('data-preview', attr);
    });

    $residency.insertBefore($(this).parent());
    $residency.addClass('addResidencyForm' + residencyIndex);

    if ($('.mentorship-preview ul').children().length > 0) {
      var $cancelBtn = $residency.find('.button-residency-cancel');
      $cancelBtn.attr('data-residency', residencyIndex);
      $cancelBtn.addClass('active');
    }

    // add preview template
    // update data-preview index
    $residencyPreview = $('#residency-preview-template').clone().removeAttr('id');

    $residencyPreview.find('.field').each(function (index) {
      var id = $(this).attr('id') + residencyIndex;
      $(this).attr('id', id);
    });
    $residencyPreview.appendTo('.mentorship-preview ul');
    $residencyPreview.addClass('addResidencyForm' + residencyIndex);


    $(".autocomplete").autocomplete({
      source: window.specialities,
      change: function (event, ui) {
        var element = event.currentTarget.id;
        if (ui.item == null || ui.item == undefined) {
          var txtSearchProNum = $("#" + element);
          txtSearchProNum.val("");
        }
      }
    });

    residencyIndex++;
  }

  var _onResidencyCancelClick = function _onResidencyCancelClick(event) {
    event.preventDefault();

    // remove from form and preview
    var id = $(this).attr('data-residency');

    $('.mentorship-preview .addResidencyForm' + id).remove();
    $(this).closest('.residency-input').remove();
  }

  //----------------------------------------------------------------------
  // Expose
  //----------------------------------------------------------------------
  return {
    init: init
  }

})();

var InternationalProgram = {

  // Selectors
  $schedule: $('.section-schedule'),
  $btnExtendedSchedule: $('.btn-extended-schedule'),
  $btnsSchedule: $('.section-schedule .button'),
  $btnJumpMenu: $('.jump-menu a'),
  $btnBackToTop: $('.back-to-top'),

  // classes
  classExpanded: "expanded",
  classHidden: "hidden",

  btnCollapsedText: "Show All",
  btnCollapsedTextCnt: " (* Events)",
  btnExpandedText: "Show Less",

  init: function init() {
    // all .schedule-item elements come from WP with .hidden,
    // remove .hidden from number of events to be shown (data-num-default-events)
    $('.section-schedule .day').each(function () {
      $(this).find('.schedule-item')
        .slice(0, InternationalProgram.$schedule.attr('data-num-default-events'))
        .removeClass(InternationalProgram.classHidden);
    });

    // InternationalProgram.updateConferenceExtras();
    InternationalProgram.updateSchedule();
    InternationalProgram.addListeners();
  },

  // vertically center .conference-extras text
  // updateConferenceExtras: function updateConferenceExtras() {
  //     $('.conference-extras li p').each(function( index ) {
  //         var $this = $(this);
  //
  //         setTimeout(function(){
  //             var parentHeight = $this.parents('li').outerHeight();
  //             var selfHeight = $this.outerHeight()
  //             var difference = (parentHeight-selfHeight)/2;
  //
  //             $this.css('margin-top', difference+'px');
  //         }, 1);
  //
  //     });
  // },

  // count number of .schedule-items in parent .day
  // update data-num-events and btn text
  updateSchedule: function updateSchedule() {
    for (var i = 0; i < InternationalProgram.$btnsSchedule.length; i++) {

      var $this = $(InternationalProgram.$btnsSchedule[i]);
      var numEvents = $this.parents('.day').find('.schedule-item').length;
      var cntText = InternationalProgram.btnCollapsedTextCnt.replace('*', numEvents);

      $this.attr('data-num-events', numEvents);
      $this.text(InternationalProgram.btnCollapsedText + cntText);
    }
  },

  addListeners: function addListeners() {
    InternationalProgram.$btnExtendedSchedule.on('click', InternationalProgram.onShowExtendedSchdule);
    InternationalProgram.$btnsSchedule.on('click', InternationalProgram.onScheduleShowCollapse);
    InternationalProgram.$btnJumpMenu.on('click', InternationalProgram.onAnchorLinkClick);
    InternationalProgram.$btnBackToTop.on('click', InternationalProgram.onBackToTopClick);
    $(window).resize(InternationalProgram.onResize);
  },

  //----------------------------------------------------------------------
  // Touch / Mouse Event Handlers
  //----------------------------------------------------------------------
  // expand / collapse all schedules
  onShowExtendedSchdule: function onShowExtendedSchdule(event) {
    event.preventDefault();

    // go through all .schedule .day and run expandCollapseSchedule
    // on each .button if it isn't already expanded.
    // force collapse if clicked to collapse

    var collapseText = 'Collapse extended schedule';
    var expandText = 'Show extended schedule';

    $(this).toggleClass(InternationalProgram.classExpanded);
    if ($(this).hasClass(InternationalProgram.classExpanded)) {
      // expand
      $('.section-schedule .day .button').each(function () {
        // check if already expanded, if so don't call
        if (!$(this).hasClass(InternationalProgram.classExpanded)) {
          InternationalProgram.expandCollapseSchedule($(this));
        }
      });
      $(this).text(collapseText);
    } else {
      //collapse
      $('.section-schedule .day .button').each(function () {
        InternationalProgram.expandCollapseSchedule($(this), true);
      });
      $(this).text(expandText);
    }
  },

  // show or hide hidden events, change button text to reflect state
  onScheduleShowCollapse: function onScheduleShowCollapse(event) {
    event.preventDefault();

    InternationalProgram.expandCollapseSchedule($(this));
  },

  // smooth scroll anchor links
  onAnchorLinkClick: function onAnchorLinkClick(event) {
    event.preventDefault();

    var target = $(this.hash);

    $('html,body').animate({
      scrollTop: target.offset().top
    }, 1000);
  },

  onBackToTopClick: function onBackToTopClick(event) {
    event.preventDefault();

    $('html,body').animate({
      scrollTop: $('.biennial').offset().top
    }, 1000);
  },

  //----------------------------------------------------------------------
  // Event Handlers
  //----------------------------------------------------------------------
  // onResize: function onResize(event) {
  //     InternationalProgram.updateConferenceExtras();
  // },

  //----------------------------------------------------------------------
  // Display
  //----------------------------------------------------------------------
  expandCollapseSchedule: function expandCollapseSchedule($btn, forceCollapse) {
    var $this = $btn;
    var $hiddenItems = $this.parents('.day').find('.schedule-item.hidden');

    // always collapse all menus if $btnExtendedSchedule is collapsed
    if (!forceCollapse) {
      $this.toggleClass(InternationalProgram.classExpanded);
      $hiddenItems.toggleClass('show');
    } else {
      $this.removeClass(InternationalProgram.classExpanded);
      $hiddenItems.removeClass('show');
    }

    // update button text
    if ($hiddenItems.hasClass('show')) {
      $this.text(InternationalProgram.btnExpandedText);
    } else {
      var cntText = InternationalProgram.btnCollapsedTextCnt.replace('*', $this.attr('data-num-events'));
      $this.text(InternationalProgram.btnCollapsedText + cntText);
    }
  }

};


var RequestCRMID = (function () {

  var init = function init() {

    _addListeners();
  }

  var _addListeners = function _addListeners() {

    $('#other-information-type').on('change', _onOtherTypeChange);
    $('.birthdate-input').on('change', _onBirthdateChange);
    $('#form-request-crm-id').on('submit', _onFormSubmit);
  }

  //----------------------------------------------------------------------
  // Form Event Handlers
  //----------------------------------------------------------------------
  var _onOtherTypeChange = function _onOtherTypeChange(event) {
    $('.other-information-field-block').hide();
    $('.other-information-field-block').find('.input').removeClass('required');

    $('[data-type="' + $(this).find(":selected").val() + '"]').find('.input').addClass('required');
    $('[data-type="' + $(this).find(":selected").val() + '"]').show();
  }

  var _onBirthdateChange = function _onBirthdateChange(event) {

    var year = $('#year').val();
    var month = $('#month').val();
    var day = $('#day').val();
    month -= 1;
    var date = new Date(year, month, day);

    if (year.toString().length > 0 && month.toString().length > 0 && day.toString().length > 0) {

      var day = date.getDate();
      var monthIndex = date.getMonth() + 1;
      var year = date.getFullYear();
      var dateString = year + '/' + monthIndex + '/' + day;

      $('#BirthDate').val(dateString);

    } else {
      $('#BirthDate').val('');
    }
  }

  var _onFormSubmit = function _onFormSubmit(event) {
    event.preventDefault();

    var errors = [];
    $(this).find('.required').each(function () {

      var inputVal;

      try {
        $(this).val().length;
        inputVal = $(this).val();
      }
      catch (error) {
        inputVal = $(this).find('option:selected').val();
      }

      if (_validateInput($(this), inputVal)) {
        // hide error
        $(this).siblings('.error').removeClass('visible');
        $(this).parent().siblings('.error').removeClass('visible');
      } else {
        // show error
        errors.push($(this));
        $(this).siblings('.error').addClass('visible');
        $(this).parent().siblings('.error').addClass('visible');
      }
    });

    if (errors.length > 0) {
      return false;
    }

    var $this = $(this);
    var formData = {};

    $.each($('.required', this).serializeArray(),
      function (i, v) {
        formData[v.name] = v.value;
      });

    var ajaxData = {
      action: 'put_crm_search_contact_id',
      crm_nonce: localized_object.nonce,
      data: formData
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        $this.find('input:not(:disabled), select:not(:disabled), textarea:not(:disabled)').prop('disabled', true);
        $this.find('input, select, label').css({ 'cursor': 'progress' });
        $this.css({ 'cursor': 'progress' });
      }
    })
      .done(function (response) {

          console.log("response.data", response.data);
        // the response is double quoted, so an empty response has a length of 2
        if (response.data.length > 2) {

          var $results = $('#results');
          var $form = $('.register-form-container');
          var href = $results.find('a').attr('href');
          var crmID = response.data;

          $results.find('.crm-id').text(crmID);
          $results.find('a').attr('href', href + '?alumni_id=' + crmID);

          // Animation setup
          $results.addClass('animate-in');
          $results.css({ 'width': $form.outerWidth() });
          $results.removeClass('hidden');
          $($results.parent()).css({ 'min-height': $results.outerHeight() });

          // Animation run
          $('#results-not-found').animate({
            'height': 0,
            'opacity': 0
          }, 500, function () {
            $(this).remove();
          });

          $('.register-form-container').animate({
            'height': 0,
            'opacity': 0
          }, 500, function () {
            $(this).remove();
          });

          $results.animate({
            'opacity': 1,
          }, 500, function () {
            $results.removeClass('animate-in');
          });

        } else {

          var $results = $('#results-not-found');

          // Animation setup
          $results.addClass('animate-in');
          $results.removeClass('hidden');

          // Animation run
          setTimeout(function () {
            var height = $results.outerHeight();
            $results.css({ 'height': 0 });
            $results.removeClass('animate-in');
            $results.animate({
              'height': height,
              'opacity': 1
            }, 300);
            $this.find('input, select').prop('disabled', false);
            $this.find('input, select, label').css({ 'cursor': 'auto' });
            $this.find('input[type="submit"]').css({ 'cursor': 'pointer' });
            $this.css({ 'cursor': 'auto' });
          }, 1);
        }
      })
      .fail(function (request, status, err) {
        console.log('ERR => ');
        console.log(err);
        console.log(request);
        console.log(status);
      }).always(function () {

      });
  }

  //----------------------------------------------------------------------
  // Utility
  //----------------------------------------------------------------------
  var _validateInput = function _validateInput($el, inputVal) {

    var validator = ($el.attr('data-validate-type')) ? $el.attr('data-validate-type') : $el.attr('type');

    switch (validator) {
      case 'text':
        return inputVal.length > 0;
        break;
      case 'date':
        return _isValidDate(inputVal);
        break;
      case 'number':
        // check for maxlength and use if exists
        if ($el.attr('maxlength')) {
          if (inputVal.length != $el.attr('maxlength')) {
            return false;
          }
        }

        return !isNaN(parseFloat(inputVal)) && isFinite(inputVal);
        break;
    }
  }

  // http://stackoverflow.com/a/6178341
  // validates date string based on format mm/dd/yyyy
  var _isValidDate = function _isValidDate(dateString) {

    // if(!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString))
    // if(!/^
    //     \d{1,2}\/ month
    //     \d{1,2}\/ day
    //     \d{4}$/ year
    //     .test(dateString))

    if (!/^\d{4}\/\d{1,2}\/\d{1,2}$/.test(dateString))
      return false;

    var parts = dateString.split("/");
    // var day = parseInt(parts[1], 10);
    // var month = parseInt(parts[0], 10);
    // var year = parseInt(parts[2], 10);
    var year = parseInt(parts[0], 10);
    var month = parseInt(parts[1], 10);
    var day = parseInt(parts[2], 10);

    if (year < 1000 || year > 3000 || month == 0 || month > 12)
      return false;

    var monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

    // Adjust for leap years
    if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
      monthLength[1] = 29;

    return day > 0 && day <= monthLength[month - 1];
  }


  //----------------------------------------------------------------------
  // Expose
  //----------------------------------------------------------------------
  return {
    init: init
  }

})();



var FeaturedProfile = (function () {

  var init = function init() {

    _addListeners();
  }

  var _addListeners = function _addListeners() {

    $('#featured-profile-enrollment-form').on('submit', _onFeaturedFormSubmit);
    $('#mayo_alumni_featured_profile_why').on('keydown', _characterCount);
  }

  //----------------------------------------------------------------------
  // Form Event Handlers
  //----------------------------------------------------------------------
  var _onFeaturedFormSubmit = function _onFeaturedFormSubmit(event) {
    event.preventDefault();

    var thisForm = $(this);
    var formData = thisForm.serializeObject();

    formData.addresses = [];
    $('.user-info .my-profile-list-item').each(function () {

      formData.addresses.push($(this).text());
    });

    // add name, email and address to data
    formData.name = $('.user-info .name').text();
    formData.email = $('.user-info .email').text();

    var ajaxData = {
      action: 'featured_profile_submission',
      data: formData
    };

    // Validation
    var validForm = true;

    if ($('#mayo_alumni_featured_profile_why').val().length < 1) {
      $('#mayo_alumni_featured_profile_why').prev().addClass('active');

      validForm = false; ``
    }

    if ($('.primary-phone-number').find('.error')) {
      $('.primary-phone-number').find('.error').addClass('active');
    }

    $('.address-required').each(function (index) {
      if ($(this).val().length < 1) {
        $(this).prev('label').addClass('error');
        validForm = false;
      } else {
        $(this).prev('label').removeClass('error');
      }
    });

    if (!validForm) return false;

    $('#mayo_alumni_featured_profile_why').prev().removeClass('active');
    $('.primary-phone-number').find('.error').removeClass('active');
    $('.business-address').find('.error').removeClass('active');


    // Add non-form data to ajaxData
    ajaxData.data.primary_phone = $('.required-phone').text();

    // Add address (if applicable) to form data
    if ($('.profile-form-address').serializeObject()) {

      // var addAddress = $('.profile-form-address').serializeArray()
      // for(var i=0; i<addAddress.length; i++) {
      //   ajaxData.data[addAddress[i].name] = addAddress[i].value;
      // }

      var address = $('.profile-form-address').serializeObject();

      ajaxData.crm_nonce = address.crm_nonce;

      delete address.crm_nonce;
      delete address._wp_http_referer;

      ajaxData.data.add_address = address;

    }

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        thisForm.find('.button').prop('disabled', 'disabled');

        // Check for name and email
        if ($('.user-info').find('.name').text().length < 1 ||
          $('.user-info').find('.email').text().length < 1) {
          return false;
        }
      }
    })
      .done(function (response) {


        // $('.submission-results').find('.title').text(response.result.title);
        // $('.submission-results').find('.message').text(response.result.message);

        $('.submission-results').find('.title').text('Success!');
        $('.submission-results').find('.message').text('We\'ll be in touch.');

      })
      .fail(function (request, status, err) {
        console.log('REQUEST => ' + request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);
      }).always(function (response, data, three, four) {
        $('.signup').slideUp();
        $('.submission-results').addClass('active');
      });
  }


  //----------------------------------------------------------------------
  // Utility
  //----------------------------------------------------------------------
  var _characterCount = function () {

    var charLength = $(this).val().length;
    $(this).next().find('span').text(($(this).attr('maxlength') - charLength));

  }

  //----------------------------------------------------------------------
  // Expose
  //----------------------------------------------------------------------
  return {
    init: init
  }

})();


var ExclusiveSwag = (function () {

  // Selectors
  var $exclusiveApparelImage = $('.exclusive-apparel--image');
  var $imgLoader = $('.exclusive-apparel--image .loader');
  var $variations = $('.exclusive-apparel--variation select');
  var $variations_count = $variations.length;
  var $selectStyle = $('#select-style');
  var $shirtDetails = $('.shirt-details');
  var $selectShirt = $('input[type=radio][name=ShirtType]');
  var $selectDues = $('input[type=radio][name=PayDues]');
  var $totalPrice = $('.total-price');
  var $selectSize = $('#select-size');
  var $additionalDonation = $('#additional-donation');
  var $swagForm = $('.swag-form');
  var $btnAddToCart = $('#btn-add-to-cart');
  var $apparel = typeof exclusiveApparel !== 'undefined' ? exclusiveApparel : false;
  var $apparel_item = '';

  var _productImages = [$exclusiveApparelImage.find('img')];
  var _cartQueue = [];

  var init = function init() {
    console.log('init');
    _addListeners();
  }

  var _addListeners = function _addListeners() {
    $variations.on('change', _onVariationChange);
    $totalPrice.on('change', _onTotalPriceChange);
    $additionalDonation.on('keyup', _onTotalPriceChange);
    $additionalDonation.on('keyup', _validate);
    $swagForm.on('submit', _onSwagFormSubmit);
    $('select').on('change', _validate);
    $('input').on('change', _validate);
  }

  //----------------------------------------------------------------------
  // Form Event Handlers
  //----------------------------------------------------------------------
  var _onVariationChange = function _onVariationChange(event) {

    var $this = $(event.target);
    var order = $this.data('order');
    $apparel_item = '';

    if ($this.val().length > 0) {

      var nextVar = order;
      $variations.eq(nextVar).prop('disabled', false);

      $variations.each(function (index, value) {
        $apparel_item += $variations.eq(index).val();
      });

      _apparelChoice();

    } else {

      $btnAddToCart.prop('disabled', true);

      for (var i = order; i <= $variations_count; i++) {

        if (i > 1) {
          $variations.eq(i).val('').prop('disabled', true);
        }

      }

    }

    $totalPrice.trigger('change');

  }

  var _apparelChoice = function () {

    $btnAddToCart.prop('disabled', false);

    if ($apparel_item && "undefined" !== typeof $apparel[$apparel_item] && $apparel[$apparel_item]['image']) {
      _swapImage($apparel[$apparel_item]['image']);
    }

  }

  var _onTotalPriceChange = function _onTotalPriceChange(event) {

    var apparel = $apparel_item && "undefined" !== typeof $apparel[$apparel_item] && "undefined" !== typeof $apparel[$apparel_item]['price'] ? $apparel[$apparel_item]['price'] : 0;
    var donation = Number($additionalDonation.val());
    //var donation = Number(0);
    var dues = ($selectDues.filter(':checked').length > 0) ? Number($selectDues.filter(':checked').attr('data-price')) : 0;
    var sum = apparel + donation + dues;
    sum = sum > 0 ? '$' + sum : '-';

    $('.exclusive-apparel--total-text').text(sum);

  }

  var _onSwagFormSubmit = function _onSwagFormSubmit(event) {
    event.preventDefault();

    _cartQueue = [];
    _validate(true);

    if (_cartQueue.length > 0) {
      _processCartQueue();
    }
  }

  //----------------------------------------------------------------------
  // Validation
  //----------------------------------------------------------------------
  var _validateSwag = function _validateSwag(showErrors) {

    var valid = false;

    if (typeof $apparel[$apparel_item] != undefined) {
      valid = true;
    }

    if (showErrors) {
      if (valid) {
        $('.exclusive-apparel--dues-error').addClass('hidden');
      } else {
        $('.exclusive-apparel--dues-error').removeClass('hidden');

        $("html, body").animate({ scrollTop: 0 }, 250);

      }

    }

    return valid;
  }


  var _validateDues = function _validateDues(showErrors) {

    var valid = false;

    // If dues are on page
    if ($selectDues.length > 0) {

      if ($selectDues.filter(':checked').length > 0) {
        valid = true;
      }

      if (showErrors) {
        if (valid) {
          $('.exclusive-apparel--dues-error').addClass('hidden');
        } else {
          $('.exclusive-apparel--dues-error').removeClass('hidden');

          $("html, body").animate({ scrollTop: 0 }, 250);

        }
      }

    } else {
      valid = true;
    }

    return valid;
  }

  var _validate = function _validate(errors) {
    showErrors = (errors == true) ? true : false;
    _cartQueue = [];

    var valid = false;

    // Dues are visible - must pay dues to buy shirt
    if ($selectDues.length > 0) {
      // Need to have dues selected and shirt
      if (_validateDues(showErrors) && _validateSwag(showErrors)) {
        valid = true;
        _processApparel();
        _processDues();
      }
    }

    // No Dues
    if (!($selectDues.length > 0)) {
      if (_validateSwag(showErrors)) {
        valid = true;
        _processApparel();
      }
    }

    // If adding an addiational donation - make sure other fields are kosher
    if ($additionalDonation.val().length > 0) {
      if (_validateDues() && _validateSwag()) {
        valid = true;
        _processDonation();
      }
    }

    if (valid && $('exclusive-apparel--total').hasClass('active')) {
      //$btnAddToCart.prop('disabled', false);
    } else {
      //$btnAddToCart.prop('disabled', true);
    }

    return valid;
  }

  //----------------------------------------------------------------------
  // Cart Methods
  //----------------------------------------------------------------------
  var _processApparel = function _processApparel() {

    if ($apparel[$apparel_item] !== undefined) {
      var apparel = $apparel[$apparel_item]['queryString'];
      _cartQueue.push(apparel);
    }

  }

  var _processDues = function _processDues() {
    var dues = '?add-to-cart=' + Number($selectDues.filter(':checked').attr('data-id')) + '&variation_id=' + Number($selectDues.filter(':checked').attr('data-variation-id')) + '&quantity=1&attribute_type=' + $selectDues.filter(':checked').attr('value');
    _cartQueue.push(dues);
  }

  var _processDonation = function _processDonation() {
    var donation = '?add-to-cart=' + Number($additionalDonation.attr('data-product-id')) + '&nyp=' + Number($additionalDonation.val());
    _cartQueue.push(donation);
  }

  var _processCartQueue = function _processCartQueue() {



    $.ajax({
      type: "POST",
      url: _cartQueue[0],
      timeout: 20000,
      beforeSend: function () {
        $btnAddToCart.prop('disabled', true);
        $btnAddToCart.addClass('loading');
        $btnAddToCart.text('');
      }
    })
      .done(function (response) {
        _cartQueue.splice(0, 1);

        if (_cartQueue.length > 0) {
          _processCartQueue();
        } else {
          window.location.href = '/cart';
        }

      })
      .fail(function (request, status, err) {
        $btnAddToCart.prop('disabled', false);
        $btnAddToCart.removeClass('loading');
        $btnAddToCart.text($btnAddToCart.attr('data-value'));
      }).always(function (response, data) {

      });

  }

  //----------------------------------------------------------------------
  // Display Methods
  //----------------------------------------------------------------------
  var _swapImage = function _swapImage(image) {

    // show loader
    $imgLoader.addClass('loading');

    var id = Date.now();
    $exclusiveApparelImage.append('<img id="' + id + '" />');
    var $img = $('#' + id);

    _productImages.push($img);

    $img.on('load', function () {

      for (var i = 0; i < _productImages.length; i++) {
        var $index = _productImages[i];
        if ($index.attr('id') != id) {
          $index.remove();
          _productImages.splice(i, 1);
        }
      }

      // hide loader
      $imgLoader.removeClass('loading');

    }).each(function () {
      if (this.complete) $(this).trigger('load');
    });

    $img.attr('src', image);
  }



  //----------------------------------------------------------------------
  // Utility
  //----------------------------------------------------------------------


  //----------------------------------------------------------------------
  // Expose
  //----------------------------------------------------------------------
  return {
    init: init
  }

})();



var MyDues = (function () {


  var $duesConfig = $('.dues-config');
  var $assocType = $duesConfig.find('input[name="association-type"]');
  var $duesType = $duesConfig.find('input[name="dues-type"]');
  var $totalCost = $duesConfig.find('.dues-config__total-cost');
  var $totalLabel = $duesConfig.find('.dues-config__total-label');
  var $productId = $duesConfig.find('.dues-config__product-id');
  var $variationId = $duesConfig.find('.dues-config__variation-id').detach();
  var $attrType = $duesConfig.find('.dues-config__attr-type').detach();
  var duesData = $duesConfig.data('products');


  var init = function init() {
    if (!$duesConfig.length) return;
    _addListeners();
    _setPriceAndVars();
  }

  var _addListeners = function _addListeners() {
    $duesType
      .add($assocType)
      .on('change', _setPriceAndVars)
      .on('change', _onCheck)
      .filter(':checked')
      .closest('label')
      .addClass('checked');
  };

  //----------------------------------------------------------------------
  // Event Handlers
  //----------------------------------------------------------------------
  var _onCheck = function _onCheck(event) {

    $('.form-dues-type').find('input[name="' + event.currentTarget.name + '"]').closest('label').removeClass('checked');
    $(this).closest('label').addClass('checked');

  }

  var _setPriceAndVars = function _setPriceAndVars() {

    var idx = $duesType.filter(':checked').val();
    var varKey = $assocType.filter(':checked').val();

    if (varKey == 'in-training') {
      $('.dues-config__opts-2 li').eq(1).hide();
    } else {
      $('.dues-config__opts-2 li').eq(1).show();
    }

    var product = duesData[idx];
    var variation = product.variations[varKey];
    $totalLabel.text(product.price_label ? ' / ' + product.price_label : '');
    $totalCost.html(variation.price);

    $productId.val(product.id);

    if (variation.id) {
      $productId.last().after($variationId).after($attrType);
      $variationId.val(variation.id);
      $attrType.val(variation.attr_type);
    } else {
      $variationId = $variationId.detach();
      $attrType = $attrType.detach();
    }

  };

  //----------------------------------------------------------------------
  // Validation
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  // Cart Methods
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  // Display Methods
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  // Utility
  //----------------------------------------------------------------------

  //----------------------------------------------------------------------
  // Expose
  //----------------------------------------------------------------------
  return {
    init: init
  }

})();

var BoardSchedule = (function () {

  var init = function init() {
    _addListeners();
  }

  var _addListeners = function _addListeners() {
    $('#maa-confidentiality-consent--checkbox').on('change', function () {
      if ($(this).is(':checked')) {
        $('#maa-confidentiality-consent--submit').prop('disabled', false);
      } else {
        $('#maa-confidentiality-consent--submit').prop('disabled', true);
      }
    })

    $('.overlay-content-close, .overlay-background, .overlay-close-btn ').on('click', function (event) {
      event.preventDefault();
      Overlay.close();
    });

    $('#maa-confidentiality-consent--form').on('submit', function (event) {
      event.preventDefault();

      var data = {
        action: $(this).attr('action'),
        wp_nonce: localized_object.nonce,
        data: $(this).serializeObject()
      };

      $.ajax({
        type: "POST",
        url: localized_object.ajax_url,
        data: data,
        dataType: "json",
        timeout: 20000,
        beforeSend: function () {

        }
      })
        .done(function (response) {

          console.log(response);

          if (response.status === 'success') {
            Overlay.close();
          }

        })
        .fail(function (request, status, err) {

          console.log('REQUEST => ' + request);
          console.log('STATUS => ' + status);
          console.log('ERR => ');
          console.log(err);

        }).always(function () {

        });

    })

  }


  return {
    init: init
  }

})();

var CustomCheckout = (function () {

  var $aboutLink;

  var _createTooltip = function () {
    return $('<a href="#" title="Not at all! Just select &ldquo;Pay with Debit or Credit Card&CloseCurlyQuote; once you&CloseCurlyQuote;ve proceeded to PayPal and you can checkout without creating an account." data-toggle="tooltip" data-placement="top" class="">Do I need a PayPal account?</a>').tooltip({
      'html': true,
      'animation': false,
      'trigger': 'click hover'
    }).on('click', function (event) {
      event.preventDefault();
    });
  };

  var _replaceLink = function () {
    $aboutLink = $('.about_paypal');
    if (!$aboutLink.length) return;
    $aboutLink
      .hide()
      .after(_createTooltip());
  };


  $('input[type="radio"][name="primary-email-selector"]').on('change', function (event) {

    if ($('input[type="radio"][name="primary-email-selector"]:checked').val() === 'update-email') {
      $('.email-field').removeClass('hidden');
    } else {
      $('.email-field').addClass('hidden');
    }
  });


  $('#form-ame-email-confirmation').on('submit', function (event) {

    event.preventDefault();

    var data = {
      "ContactId": $('input[name=ContactID]').val(),
      "EmailConfirmationConfirmed": true
    };


    if ($('input[type="radio"][name="primary-email-selector"]:checked').val() === 'update-email' ||
      $(this).hasClass('no-email')) {

      if (Helpers.isValidEmail($('#primary-email-updated').val())) {
        $(this).find('.alert-error').addClass('hidden');
        data.PrimaryEmail = $('#primary-email-updated').val();
        updateSession(data);

      } else {
        $(this).find('.alert-error').removeClass('hidden');
      }
    } else {

      updateSession(data);

    }


  })


  var updateSession = function updateSession(data) {

    var ajaxData = {
      action: 'ame_email_confirmation',
      wp_nonce: localized_object.nonce,
      data: data
    };

    $.ajax({
      type: "POST",
      url: localized_object.ajax_url,
      data: ajaxData,
      dataType: "json",
      timeout: 20000,
      beforeSend: function () {
        $('button[type=submit]').attr('disabled', true);
      }
    })
      .done(function (response) {

        location.reload();

      })
      .fail(function (request, status, err) {

        console.log('REQUEST => ', request);
        console.log('STATUS => ' + status);
        console.log('ERR => ');
        console.log(err);
        console.log('');

        $('button[type=submit]').attr('disabled', false);

      }).always(function () {

      });

  }




  var init = function init() {
    _replaceLink();
    $(document.body).on('updated_checkout', _replaceLink);
  };

  return {
    init: init
  };

})();

$(function () {
  var $body = $(document.body);

  // InternationalProgram.init();
  // Mentorship.init();

  if ($body.hasClass('page-2019-biennial')) {
    InternationalProgram.init();
  }

  if ($body.hasClass('page-2021-biennial')) {
    InternationalProgram.init();
  }

  if ($body.hasClass('page-connect') ||
    $body.hasClass('page-mccn-job-search')) {

    // MenteeConnect.init();
  }

  if ($body.hasClass('page-request-crm-id') ||
    $body.hasClass('page-request-crm-id-fb')) {
    RequestCRMID.init();
  }

  if ($body.hasClass('page-featured-profile')) {
    FeaturedProfile.init();
  }

  if ($body.hasClass('page-my-dues')) {
    MyDues.init();
  }

  if ($body.hasClass('page-checkout')) {
    CustomCheckout.init();
  }

  if ($body.hasClass('page-mentorship')) {
    Mentorship.init();
  }

  if ($body.hasClass('page-template-page-board-schedule-php')) {
    BoardSchedule.init();
  }

  if ($body.hasClass('page-limited-edition-yeti-lunchbox')) {
    ExclusiveSwag.init();
  }



  // Page is no longer active
  if ($('body').hasClass('page-limited-time-apparel')) {
    ExclusiveSwag.init();
  }

});

$(function () {
  $('.product-search-icon-img').on('click', function (e) {
    e.preventDefault();
    $('.product-search').addClass('visible');
    $('.title-icon').addClass('hidden');
  });
});

// Find Alumni related JS
$(function() {
  $('.select-trigger, .checkbox-trigger').on('click',function(e) {
    e.preventDefault()
    $(this).toggleClass('active')
    $(this).closest('.custom-dropdown').toggleClass('active')
  })

  $('.custom-select .custom-options > div').on('click', function(e) {
    e.preventDefault()
    $(this).closest('.custom-dropdown').find('select').val($(this).data('attr'))
    $('.custom-options > div').removeClass('active')
    $(this).addClass('active')
    $(this).closest('.custom-select').find('.select-trigger').find('span').html($(this).data('attr'));
    $(this).closest('.custom-select').find('.select-trigger').click();
  })

  $('.custom-checkbox .custom-options > div').on('click', function(e) {
    e.preventDefault()
    $(this).find('.checkmark').toggleClass('active')

    if ($(this).find('.checkmark').hasClass('active')) {
      $(this).closest('.custom-dropdown').find($('input[type="checkbox"][value="' + $(this).data('attr') + '"]')).prop('checked', true);
    } else {
      $(this).closest('.custom-dropdown').find($('input[type="checkbox"][value="' + $(this).data('attr') + '"]')).prop('checked', false);
    }
  })

  $('.inline-checkbox > div').on('click', function(e) {
    e.preventDefault()
    $(this).find('.checkmark').toggleClass('active')

    if ($(this).find('.checkmark').hasClass('active')) {
      $(this).closest('.custom-dropdown').find($('input[type="checkbox"][value="' + $(this).data('attr') + '"]')).prop('checked', true);
    } else {
      $(this).closest('.custom-dropdown').find($('input[type="checkbox"][value="' + $(this).data('attr') + '"]')).prop('checked', false);
    }
  })

  $('#back-to-search').click(function(e){
    e.preventDefault();
    window.history.back();
  });


  function updateSummary() {
    var selected = [];
    $('input[name="i[]"]:checked').each(function() {
      selected.push($(this).val());
    });
    var summaryText = selected.length > 0 ? "Selected: " + selected.join(", ") : "Select Topics";
    $('.group-checkboxes summary').text(summaryText);
  }

  // Attach the update function to checkbox changes
  $('input[name="i[]"]').on('change', updateSummary);

  // Initial update in case of pre-checked checkboxes
  updateSummary();
  
  // Email character filtering
  function initEmailCharacterFiltering() {
    // Define valid email characters regex (letters, numbers, @, ., -, _, +)
    var validEmailChars = /[^a-zA-Z0-9@._+-]/g;
    
    // Target all email input fields
    var emailSelectors = [
      'input[type="email"]',
      'input[name="email"]',
      'input[name="email_confirm"]',
      'input[name="email-confirm"]', 
      'input[name="user_login"]',
      'input[name*="email"]',
      'input[id*="email"]',
      'input[placeholder*="Email"]',
      'input[placeholder*="email"]'
    ].join(', ');
    
    $(document).on('input paste keyup', emailSelectors, function(e) {
      var $input = $(this);
      var cursorPosition = this.selectionStart;
      var originalValue = $input.val();
      var filteredValue = originalValue.replace(validEmailChars, '');
      
      // Only update if value changed (to avoid infinite loops)
      if (originalValue !== filteredValue) {
        $input.val(filteredValue);
        
        // Restore cursor position, adjusting for removed characters
        var removedChars = originalValue.length - filteredValue.length;
        var newCursorPosition = Math.max(0, cursorPosition - removedChars);
        
        // Set cursor position back
        if (this.setSelectionRange) {
          this.setSelectionRange(newCursorPosition, newCursorPosition);
        }
      }
    });
    
    // Handle paste events specifically to clean pasted content
    $(document).on('paste', emailSelectors, function(e) {
      var $input = $(this);
      
      // Use setTimeout to allow paste to complete first
      setTimeout(function() {
        var originalValue = $input.val();
        var filteredValue = originalValue.replace(validEmailChars, '');
        
        if (originalValue !== filteredValue) {
          $input.val(filteredValue);
        }
      }, 10);
    });
  }
  
  // Initialize email character filtering
  initEmailCharacterFiltering();
});

/**
 * Mobile menu and submenu handling
 */
(function ($) {
  //Body class if mobile menu is open
  const mobileMenuTrigger = document.getElementById('mobile-menu-trigger');
  const $submenus = $('.mayo-nav-collapsible-menu .sub-menu');
  const $submenuLinks = $('.mayo-nav-collapsible-menu .sub-menu a');

// Check if the mobile menu trigger element exists
  if (mobileMenuTrigger) {
    // Initialize tabindex for all submenus on page load (collapsed by default)
    makeSubmenusNotTabAccessible();

    mobileMenuTrigger.addEventListener('click', (function () {
      $('body').toggleClass('mobile-menu-open');

      // Toggle aria-expanded attribute for accessibility
      const isMenuOpen = $('body').hasClass('mobile-menu-open');
      mobileMenuTrigger.setAttribute('aria-expanded', isMenuOpen);

      if (isMenuOpen) {
        // Initialize tabindex for all submenus when main menu opens
        makeSubmenusNotTabAccessible();

        const mobileSubmenuTrigger = $('.btn-submenu-toggle');

        //JS to handle expand/collapse submenus
        mobileSubmenuTrigger.on('click', function () {
          const isExpanded = this.getAttribute('aria-expanded') === 'true';
          const menuItemWrapper = $(this).closest('.menu-item-wrapper');

          // Find the submenu relative to this button instead of using aria-controls
          // Go up to the parent .menu-item and find the .sub-menu within it
          const menuItem = $(this).closest('.menu-item');
          const submenu = menuItem.find('.sub-menu')[0]; // Get the DOM element

          // Check if the submenu element exists
          if (submenu) {
            // If we're opening this submenu, close other submenus (but preserve ancestors)
            if (!isExpanded) {
              // Target only open submenus
              $('.mayo-nav-collapsible-menu .btn-submenu-toggle[aria-expanded="true"]').each(function () {
                const button = this;
                const otherMenuItem = $(button).closest('.menu-item')[0];

                // Don't affect the current menu item
                if (otherMenuItem !== menuItem[0]) {
                  const otherSubmenu = $(otherMenuItem).find('.sub-menu')[0];

                  if (otherSubmenu) {
                    // Check if this submenu is an ancestor of the current menu item
                    // If the current menuItem is contained within this otherSubmenu, it's an ancestor
                    const isAncestor = $(otherSubmenu).find(menuItem).length > 0;

                    // Only close if it's not an ancestor submenu
                    if (!isAncestor) {
                      button.setAttribute('aria-expanded', 'false');
                      otherSubmenu.setAttribute('aria-hidden', 'true');
                      otherSubmenu.classList.remove('is-expanded');
                      // Also remove the is-open class from the wrapper
                      $(otherMenuItem).find('.menu-item-wrapper').removeClass('is-open');
                      // Make the closed submenu not tab-accessible
                      makeSpecificSubmenuNotTabAccessible($(otherSubmenu));
                    }
                  }
                }
              });
            }

            // Toggle the current submenu
            this.setAttribute('aria-expanded', !isExpanded);
            submenu.setAttribute('aria-hidden', isExpanded);
            submenu.classList.toggle('is-expanded');
            menuItemWrapper.toggleClass('is-open');

            // Toggle tabindex for accessibility - allow tab navigation when expanded
            if (!isExpanded) {
              // Expanding: remove tabindex restrictions
              makeSpecificSubmenuTabAccessible($(submenu));
            } else {
              // Collapsing: add tabindex -1 to prevent tab navigation
              makeSpecificSubmenuNotTabAccessible($(submenu));
            }
          }
        });
      } else {
        // Main menu is closing - ensure all submenus are not tab-accessible
        makeSubmenusNotTabAccessible();
      }
    }));

    //main mobile menu is controlled by Bootstrap's collapse.js
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        const mainMobileMenu = $('#mayo-navbar-collapse');

        // Check if mobile menu is currently open (has 'in' class in Bootstrap 3)
        if (mainMobileMenu.hasClass('in')) {
          // Use Bootstrap's collapse API to hide the menu
          mainMobileMenu.collapse('hide');

          // Return focus to the menu trigger button for accessibility
          mobileMenuTrigger.focus();
        }
      }
    });

    // Helper functions for tabindex management
    function makeSubmenusNotTabAccessible() {
      $submenus.attr('tabindex', '-1');
      $submenuLinks.attr('tabindex', '-1');
    }

    function makeSpecificSubmenuTabAccessible($submenu) {
      $submenu.removeAttr('tabindex');
      $submenu.find('a').removeAttr('tabindex');
    }

    function makeSpecificSubmenuNotTabAccessible($submenu) {
      $submenu.attr('tabindex', '-1');
      $submenu.find('a').attr('tabindex', '-1');
    }
  }
}(jQuery));


/* Insecure password notification in header (cookie/attrs) */
(function () {
  if (!window.MayoPasswordSessionNotice) return;
  const cfg = window.MayoPasswordSessionNotice;

  // run after DOM is ready (safe even if enqueued in footer)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const pwNotice = document.getElementById('pw-notification');
    const dismissPwNoticeBtn = document.getElementById('btn-dismiss-pw-notice');
    if (!pwNotice || !dismissPwNoticeBtn) return;

    const hasCookie = document.cookie.split('; ').some(r => r.startsWith(cfg.cookieName + '='));

    // bail if user doesn't need update or cookie already set
    if (!cfg.mayo_user_needs_pw_update || hasCookie) {
      pwNotice.setAttribute('hidden', '');
      pwNotice.classList.remove('active');
      return;
    }

    // show
    pwNotice.removeAttribute('hidden');
    pwNotice.classList.add('active');

    // dismiss handler
    dismissPwNoticeBtn.addEventListener('click', function () {
      document.cookie = [
        cfg.cookieName + '=1',
        'Path=' + cfg.path,
        'SameSite=Lax',
        (cfg.secure ? 'Secure' : '')
      ].filter(Boolean).join('; ');

      pwNotice.setAttribute('hidden', '');
      pwNotice.classList.remove('active');
    });
  }
})();

(function () {
  // run after DOM is ready (safe even if enqueued in footer)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDuesPopup);
  } else {
    initDuesPopup();
  }

  function initDuesPopup() {
    const userOwesDues = localized_object.user_owes_dues;
    const duesPopupEnabled = localized_object.dues_popup_enabled;
    const duesPopupCfg = window.MayoDuesPopupSession;

    if ((typeof userOwesDues !== 'undefined' && userOwesDues === '1') && (typeof duesPopupEnabled !== 'undefined' && duesPopupEnabled === '1')) {
      const dialog = document.getElementById('overlay-dues');
      const closeBtn = document.getElementById('close-dues-overlay-btn');
      let lastFocusedElement = document.activeElement;

      if (!dialog || !closeBtn) return;

      const hasDuesCookie = document.cookie.split('; ').some(r => r.startsWith(duesPopupCfg.cookieName + '='));

      if (hasDuesCookie) {
        return;
      }

      //Opens on the homepage only, after 12 seconds
      setTimeout(() => {
        openDuesPopup(dialog);
      }, 12000);


      // Handle close button
      closeBtn.addEventListener('click', function () {
        closeDuesPopup(dialog);
      });

      // Handle escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          const activeDialog = document.querySelector('dialog[open]');
          if (activeDialog) {
            closeDuesPopup(dialog);
          }
        }
      });

      function openDuesPopup(dialog) {
        dialog.showModal();
        document.body.classList.add('dues-overlay-open');
      }

      function closeDuesPopup(dialog) {
        dialog.close();
        document.body.classList.remove('dues-overlay-open');

        //Add session cookie
        document.cookie = [
          duesPopupCfg.cookieName + '=1',
          'Path=' + duesPopupCfg.path,
          'SameSite=Lax',
          (duesPopupCfg.secure ? 'Secure' : '')
        ].filter(Boolean).join('; ');

        if (lastFocusedElement) {
          lastFocusedElement.focus();
        }
      }
    }
  }
})();



// A11y enhancements for Gravity Forms multiselect fields
(function() {
  // Minimal visually-hidden CSS if not already present
  var srOnlyCSS = '.sr-only{position:absolute!important;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;}';
  var styleTag = document.createElement('style');
  styleTag.appendChild(document.createTextNode(srOnlyCSS));
  document.head.appendChild(styleTag);

  function enhanceChosenSearchInputs(scope) {
    var fields = (scope || document).querySelectorAll('.gfield--type-multiselect .ginput_container_multiselect');
  fields.forEach(function(container){
      var select = container.querySelector('select[multiple]');
  if (!select) return;

  var gfField = container.closest('.gfield');
  var fieldLabelEl = gfField ? gfField.querySelector('label[for="' + select.id + '"]') : null;
  var fieldLabelText = (fieldLabelEl ? fieldLabelEl.textContent : '').trim() || 'Options';

  var chosen = container.querySelector('.chosen-container');
  if (!chosen) return;

  var resultsList = chosen.querySelector('.chosen-results');
  if (resultsList && !resultsList.id) {
    resultsList.id = select.id + '_results';
      }

  var searchInput = chosen.querySelector('.chosen-search-input');
  if (!searchInput) return;

  // Skip if already done
  if (searchInput.dataset.a11yEnhanced === 'true') return;

  // 1) Add aria-label derived from field label
  var ariaLabel = fieldLabelText + ' — search to narrow options';
  searchInput.setAttribute('aria-label', ariaLabel);

  // 2) Add visually hidden instructions (optional)
  var helperId = select.id + '_search_help';
  if (!document.getElementById(helperId)) {
        var help = document.createElement('span');
  help.id = helperId;
  help.className = 'sr-only';
  help.textContent = 'Type to filter the list of options. Use arrow keys to navigate and Enter to select.';
  chosen.appendChild(help);
      }
  searchInput.setAttribute('aria-describedby', helperId);

  // 3) Connect to the Chosen results list
  if (resultsList && resultsList.id) {
    searchInput.setAttribute('aria-controls', resultsList.id);
      }

  // Mark as enhanced
  searchInput.dataset.a11yEnhanced = 'true';
    });
  }

  function onGFormRendered(cb){
    if (window.jQuery) {
    jQuery(document).on('gform_post_render', function () { cb(); });
    }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { cb(); });
    } else {
    cb();
    }
  }

  onGFormRendered(function(){enhanceChosenSearchInputs(document); });

  var gfWrap = document.querySelector('.gform_wrapper');
  if (gfWrap && 'MutationObserver' in window) {
    var mo = new MutationObserver(function(){
    enhanceChosenSearchInputs(gfWrap);
    });
  mo.observe(gfWrap, {childList: true, subtree: true });
  }
})();